// extracted by mini-css-extract-plugin
export default {"productCarousel":"qca-z","itemsContainer":"rca-z"};